/*! jQuery Lazy - Media Breakpoints
* Prefined classes to match boostrap media breakpoints for jquery lazy 
* Example: .lazy-sm-up or .lazy-md-down */

(function ( $ ) {
 
    $.Lazy.media_breakpoints = function( options ) {
    		
    		// Default options
        var settings = $.extend({
            breakpoints: {
            	'sm' : 576,
            	'md' : 768,
            	'lg' : 992,
            	'xl' : 1260
            }
        }, options );

        // Create media breakpoint classes
				setMediaBreakpoints = function() {
					if(settings.breakpoints) {

						 $.each(settings.breakpoints, function(index, value) {

						 	 if($(window).width() <= value) {
							 	 var breakpoint = index;
					 	 		 $("[data-src-" + index + "]").each(function() {
							 	 		$(this).attr("data-src", $(this).data("src-" + breakpoint));
							 	 });
					 	 		 $("[data-srcset-" + index + "]").each(function() {
							 	 		$(this).attr("data-srcset", $(this).data("srcset-" + breakpoint));
							 	 }); 	 
						 	 	 return;
						 	 }

						 });
					}
				}

				// Init
        setMediaBreakpoints();

    };
 
}( jQuery ));